import { useEffect, useState } from "react";
import { gql, useLazyQuery } from "@apollo/client";
import { Skeleton, Drawer, Space } from "antd";
import { useParams } from "react-router-dom";
import OtherErrors from "@general/otherErrors";
import moment from "moment-jalaali";
import ServicesTable from "./table";
import PurchasesTableDetails from "./tableDetails";
import TableFilters from "@general/tableFilters";
import getWindowSize from "@utils/windowSize";
import PurchasesControl from "./purchasesControl";

const GETPURCHASES = gql`
  query ($paginateInput: PaginateInput!, $searchInput: PurchaseSearchInput!) {
    getPurchasesCount(searchInput: $searchInput)
    getPurchases(paginateInput: $paginateInput, searchInput: $searchInput) {
      id
      createdAt
      purchaseType
      reserve{
      startAt
      endAt
      }
      user {
        id
        name
        mobile
        userRole
      }
      product {
        name
        category
        packages {
          product {
            id
          }
        }
      }
      startAt
      endAt
      amount
      description
    }
  }
`;

function UsersPurchases(props) {
  const [tableData, setTableData] = useState({});
  const [currentPage, setCurrentPage] = useState();
  const [sortDir, setSortDir] = useState("desc");
  const [sortColumn, setSortColumn] = useState("createdAt");
  const [filterDateFrom, setFilterDateFrom] = useState(null);
  const [filterDateTo, setFilterDateTo] = useState(null);
  const [filterSearchPhrase, setFilterSearchPhrase] = useState("");
  const [drawer, setDrawer] = useState(false);

  const windowSize = getWindowSize().innerWidth;

  const [getPurchases, purchases] = useLazyQuery(GETPURCHASES, {
    fetchPolicy: "no-cache",
    onCompleted(data) {
      setTableData(data);
    },
  });
  const { result } = useParams();
  useEffect(() => {
    getPurchases({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {
          userId: result !== "all" ? result : null,
          // isForConsultation:true,
          createdAt:
            filterDateFrom && filterDateTo
              ? [filterDateFrom, filterDateTo]
              : null,
          textSearch: filterSearchPhrase,
        },
      },
    });
  }, [currentPage, sortDir, filterDateTo, filterSearchPhrase]);

  const dataUpdated = () => {
    getPurchases({
      variables: {
        paginateInput: {
          page: currentPage,
          perPage: 10,
          sort: sortColumn && sortColumn,
          sortDir: sortDir,
        },
        searchInput: {},
      },
    });
  };

  const pageChange = (current) => {
    setCurrentPage(current);
  };

  const sort = (sortData) => {
    setCurrentPage(1);
    setSortColumn(sortData.columnKey);
    if (sortData.order === "ascend") setSortDir("asc");
    if (!sortData.order || sortData.order === "descend") setSortDir("desc");
  };

  const filterDate = (dates, dateString) => {
    setCurrentPage(1);
    if (dateString[0] === "" || dateString[1] === "") {
      setFilterDateFrom(null);
      setFilterDateTo(null);
    } else {
      setFilterDateFrom(
        moment(dateString[0], "jYYYY/jMM/jDD")
          .startOf("day")
          .toDate()
          .toISOString()
      );
      setFilterDateTo(
        moment(dateString[1], "jYYYY/jMM/jDD")
          .endOf("day")
          .toDate()
          .toISOString()
      );
    }
  };

  const filterSearch = (phrase) => {
    setCurrentPage(1);
    setFilterSearchPhrase(phrase);
  };

  const openDrawer = (id, name) => {
    setDrawer({ id, name });
  };
  const closeDrawer = () => {
    setDrawer(false);
  };
  if (purchases.error) return <OtherErrors />;
  if (Object.keys(tableData).length === 0)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );

  return (
    <>
      <Drawer
        title="جزییات خرید"
        placement="right"
        open={drawer}
        onClose={closeDrawer}
        size={windowSize >= 750 ? "large" : null}
        width={windowSize < 750 ? windowSize - 50 : null}
      >
        <PurchasesControl
          id={drawer.id}
          onDataUpdate={dataUpdated}
          onCloseDrawer={closeDrawer}
        />
        {/* <PurchasesTableDetails
          id={drawer.id}
          onDataUpdate={dataUpdated}
          onCloseDrawer={closeDrawer}
        /> */}
      </Drawer>

      <TableFilters onFilterDate={filterDate} onFilterSearch={filterSearch} />
      <Space></Space>
      <br />
      <ServicesTable
        onDataUpdate={dataUpdated}
        data={tableData}
        onSort={sort}
        onPageChange={pageChange}
        currentPage={currentPage}
        loading={purchases.loading}
        onOpenDrawer={openDrawer}
      />
    </>
  );
}

export default UsersPurchases;
